// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".searchFilters__item{margin-bottom:3rem}@media(max-width:1024px){.searchFilters__item--FormCheckboxList,.searchFilters__item--FormRadio,.searchFilters__item--FormRange{margin-bottom:0}}.searchFilters__item--FormCheckbox{margin-top:3rem}.searchFilters__item--FormRange{padding-bottom:1rem}@media(max-width:1024px){.searchFilters__item--FormRange{border-bottom:1px solid #e6e6e6;padding-bottom:4rem;padding-top:3rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
